import { SVG_CHEVRON_LEFT, SVG_CHEVRON_RIGHT } from './icons';

export function isCompactPaginationViewport() {
	return typeof window !== 'undefined' && window.matchMedia('(max-width: 1023px)').matches;
}

export function getPageNumbers(current, total) {
	const compact = isCompactPaginationViewport();
	const edge = compact ? 3 : 5;
	const siblings = 1;
	const maxPagesShowAll = compact ? 5 : 7;

	if (total <= maxPagesShowAll) {
		return Array.from({ length: total }, (_, i) => i + 1);
	}

	const pages = [];
	const nearStart = current <= siblings + 2;
	const nearEndThreshold = compact ? 1 : siblings + 1;
	const nearEnd = current >= total - nearEndThreshold;

	if (nearStart) {
		for (let i = 1; i <= edge; i++) pages.push(i);
		pages.push('...');
		pages.push(total);
	} else if (nearEnd) {
		const endEdge = compact ? 2 : 3;
		pages.push(1);
		pages.push('...');
		for (let i = total - endEdge + 1; i <= total; i++) pages.push(i);
	} else {
		pages.push(1);
		pages.push('...');
		pages.push(current);
		pages.push('...');
		pages.push(total);
	}

	return pages;
}

export function renderPagination({ pagesEl, rangeEl, wrapEl, paged, totalPages, totalPosts, postsPerPage, cssPrefix }) {
	if (!pagesEl) return;

	if (totalPages <= 1) {
		pagesEl.innerHTML = '';
		if (rangeEl) {
			if (totalPosts > 0) {
				const end = Math.min(postsPerPage, totalPosts);
				rangeEl.textContent = `1–${end} of ${totalPosts}`;
			} else {
				rangeEl.textContent = '';
			}
		}
		return;
	}

	const parts = [];

	parts.push(
		`<button type="button" class="${cssPrefix}__control${paged <= 1 ? ' is-disabled' : ''}" data-page="${paged - 1}">` +
			`${SVG_CHEVRON_LEFT}<span class="${cssPrefix}__control-text">Back</span>` +
		'</button>',
	);

	for (const p of getPageNumbers(paged, totalPages)) {
		if (p === '...') {
			parts.push(`<span class="${cssPrefix}__ellipsis">...</span>`);
		} else {
			parts.push(
				`<button type="button" class="${cssPrefix}__page${p === paged ? ' is-active' : ''}" data-page="${p}">${p}</button>`,
			);
		}
	}

	parts.push(
		`<button type="button" class="${cssPrefix}__control${paged >= totalPages ? ' is-disabled' : ''}" data-page="${paged + 1}">` +
			`<span class="${cssPrefix}__control-text">Next</span>${SVG_CHEVRON_RIGHT}` +
		'</button>',
	);

	pagesEl.innerHTML = parts.join('');

	if (rangeEl) {
		const start = (paged - 1) * postsPerPage + 1;
		const end = Math.min(paged * postsPerPage, totalPosts);
		rangeEl.textContent = `${start}\u2013${end} of ${totalPosts}`;
	}
}

export function onPaginationViewportChange(callback) {
	if (typeof window === 'undefined') {
		return () => {};
	}
	const mq = window.matchMedia('(max-width: 1023px)');
	const handler = () => callback();
	mq.addEventListener('change', handler);
	return () => mq.removeEventListener('change', handler);
}
